import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {addDeposit, verifyPaymentLink} from "../api/routes";
import {Backdrop, CircularProgress} from "@mui/material";

export default function Pay(){
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()
    useEffect(() => {
        setLoading(true)
        verifyPaymentLink(searchParams.get("q"),(isOk,data)=>{
            if(!isOk){
                setLoading(false)
                navigate("/")
                return alert(data.message);
            }
            else {
                const depositData = {
                    patientId:data.patientId
                }
                addDeposit(depositData, (isOk, data) => {
                    if (!isOk) {
                        setLoading(false)
                        return alert(data.message);
                    }
                    else {
                        setLoading(false)
                        return window.location.replace(`https://sadad.shaparak.ir/VPG/Purchase?Token=${data.token}`);
                    }
                })
            }
        })
    }, [searchParams]);
    return(<>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
            <CircularProgress color="inherit" />
        </Backdrop>
    </>)
}
